(() => {
  const ICON_TRUCK = '<svg class="cassava-icon" width="1.15em" height="1.15em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h11v10H3z"/><path d="M14 9h4l3 3v4h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>';
  const ICON_STAR = '<svg class="cassava-icon" width="1.15em" height="1.15em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m12 3.5 2.6 5.3 5.9.9-4.3 4.1 1 5.8-5.2-2.7-5.2 2.7 1-5.8-4.3-4.1 5.9-.9z"/></svg>';
  const ICON_CHECK = '<svg class="cassava-icon" width="1.15em" height="1.15em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';
  const DEFAULT_GOAL = 150000;
  const MAX_FREE_WEIGHT_GRAMS = 20000;
  const LOYALTY_GOAL = 250000;
  const LOYALTY_HINT_FROM = 100000;
  let requestInFlight = null;

  function getCurrency() {
    return window.Shopify?.currency?.active || 'MXN';
  }

  function formatMoney(cents) {
    const amount = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: getCurrency(),
        /* Opción B: formato de marca, $1,500 (sin centavos cuando son cero) */
        minimumFractionDigits: Number(cents || 0) % 100 ? 2 : 0,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (error) {
      return `$ ${amount.toFixed(2)}`;
    }
  }

  function formatKg(grams) {
    const kg = Number(grams || 0) / 1000;
    return `${kg.toLocaleString('es-MX', { maximumFractionDigits: 1 })} kg`;
  }

  function ensureDrawerStyles() {
    if (document.getElementById('cassava-cart-drawer-progress-styles')) return;
    const style = document.createElement('style');
    style.id = 'cassava-cart-drawer-progress-styles';
    style.textContent = `
      .cart-drawer__shipping-progress{margin:0 0 1.2rem;padding:1.2rem 1.4rem;border:1px solid rgba(var(--color-foreground),.12);border-radius:1.2rem;background:rgba(var(--color-foreground),.03)}
      .cart-drawer__shipping-progress[hidden]{display:none}
      .cart-drawer__shipping-progress-title{margin:0;font-size:1.3rem;line-height:1.4;font-weight:600}
      .cart-drawer__shipping-progress-subtitle{margin:.3rem 0 0;font-size:1.1rem;line-height:1.35;opacity:.72}
      .cart-drawer__shipping-progress-track{display:block;width:100%;height:.5rem;margin-top:.8rem;overflow:hidden;border-radius:999px;background:rgba(var(--color-foreground),.12)}
      .cart-drawer__shipping-progress-fill{display:block;width:0;height:100%;border-radius:999px;background:rgb(var(--color-foreground));transition:width .25s ease}
    `;
    document.head.appendChild(style);
  }

  function ensureDrawerBanner() {
    const drawer = document.querySelector('#CartDrawer');
    const drawerFooter = drawer && drawer.querySelector('.cart-drawer__footer');
    if (!drawerFooter) return null;

    let banner = drawer.querySelector('[data-cassava-free-shipping-banner]');
    if (banner) return banner;

    ensureDrawerStyles();
    banner = document.createElement('div');
    banner.className = 'cart-drawer__shipping-progress';
    banner.dataset.cassavaFreeShippingBanner = '';
    banner.dataset.freeShippingGoal = String(DEFAULT_GOAL);
    banner.dataset.cassavaHideWhenEmpty = 'true';
    banner.hidden = true;
    banner.innerHTML = `
      <p class="cart-drawer__shipping-progress-title" data-cassava-free-shipping-title>Calculando tu envío gratis…</p>
      <p class="cart-drawer__shipping-progress-subtitle" data-cassava-free-shipping-subtitle>Envío estándar gratis desde $1,500 MXN en pedidos de hasta 20 kg.</p>
      <span class="cart-drawer__shipping-progress-track" aria-hidden="true">
        <span class="cart-drawer__shipping-progress-fill" data-cassava-free-shipping-progress></span>
      </span>
    `;

    // v4.43: la barra de envío gratis va arriba, justo debajo del título del carrito (es donde más motiva).
    const header = drawer.querySelector('.drawer__header');
    if (header) {
      header.insertAdjacentElement('afterend', banner);
    } else {
      const totals = drawerFooter.querySelector('.totals');
      drawerFooter.insertBefore(banner, totals || drawerFooter.firstChild);
    }
    return banner;
  }

  // Misma tabla que Envío y entrega (Perfil general): límite superior en kg, estándar y express.
  const SHIPPING_TIERS = [
    { maxKg: 5, standard: 10000, express: 26000 },
    { maxKg: 10, standard: 19500, express: 43000 },
    { maxKg: 20, standard: 25500, express: 78000 },
    { maxKg: 30, standard: 31500, express: 112000 },
    { maxKg: 50, standard: 43500, express: 173000 },
    { maxKg: 70, standard: 64500, express: 241000 }
  ];

  function shippingTier(grams) {
    const kg = Number(grams || 0) / 1000;
    return SHIPPING_TIERS.find((tier) => kg <= tier.maxKg) || null;
  }

  function updateShippingEstimate(banner, cart) {
    let line = banner.querySelector('[data-cassava-ship-estimate]');
    if (!line) {
      line = document.createElement('p');
      line.dataset.cassavaShipEstimate = '';
      line.style.cssText = 'margin:.8rem 0 0;font-size:1.15rem;line-height:1.4;';
      const note = banner.querySelector('[data-cassava-loyalty-note]');
      banner.insertBefore(line, note || null);
    }

    const goal = Number(banner.dataset.freeShippingGoal) || DEFAULT_GOAL;
    const tier = shippingTier(cart.total_weight);
    const weight = Number(cart.total_weight || 0) > 0 ? ` · pesa ${formatKg(cart.total_weight)}` : '';

    if (!tier) {
      line.innerHTML = `${ICON_TRUCK} Tu pedido pesa ${formatKg(cart.total_weight)}: para más de 70 kg <a href="https://wa.me/5215648239669" target="_blank" rel="noopener">cotizamos el envío por WhatsApp</a>, o recógelo gratis en almacén.`;
      return;
    }

    const freeStandard = cart.total_price >= goal && Number(cart.total_weight || 0) <= MAX_FREE_WEIGHT_GRAMS;
    const standard = freeStandard ? '<strong>gratis</strong>' : `<strong>${formatMoney(tier.standard)}</strong>`;
    line.innerHTML = `${ICON_TRUCK} Envío estimado: estándar ${standard} · express ${formatMoney(tier.express)}${weight}. También puedes recoger gratis.`;
  }

  function isLoggedIn() {
    return Boolean(window.ShopifyAnalytics?.meta?.page?.customerId);
  }

  function updateLoyaltyNote(banner, cart) {
    let note = banner.querySelector('[data-cassava-loyalty-note]');
    if (!note) {
      note = document.createElement('p');
      note.dataset.cassavaLoyaltyNote = '';
      note.style.cssText = 'margin:.8rem 0 0;font-size:1.15rem;line-height:1.4;';
      banner.appendChild(note);
    }

    const original = typeof cart.original_total_price === 'number' ? cart.original_total_price : cart.total_price;
    const loginUrl = window.routes?.account_login_url || '/account/login';

    if (original >= LOYALTY_GOAL) {
      note.hidden = false;
      note.innerHTML = isLoggedIn()
        ? ICON_STAR + ' Tu compra califica para el <strong>Plan de Lealtad</strong>: el descuento de tu nivel se aplica en el checkout.'
        : `${ICON_STAR} Tu compra califica para el <strong>Plan de Lealtad</strong> (3 % en tu primera compra). ¿Ya tienes nivel? <a href="${loginUrl}">Inicia sesión</a> para que se aplique tu descuento.`;
    } else if (original >= LOYALTY_HINT_FROM) {
      note.hidden = false;
      note.innerHTML = `${ICON_STAR} Agrega ${formatMoney(LOYALTY_GOAL - original)} más y obtén <strong>3 % de descuento</strong> al entrar al Plan de Lealtad.`;
    } else {
      note.hidden = true;
    }
  }

  function updateBanner(cart) {
    if (!cart || typeof cart.total_price !== 'number') return;

    ensureDrawerBanner();
    const banners = document.querySelectorAll('[data-cassava-free-shipping-banner]');
    if (!banners.length) return;

    const overWeight = Number(cart.total_weight || 0) > MAX_FREE_WEIGHT_GRAMS;

    banners.forEach((banner) => {
      const goal = Number(banner.dataset.freeShippingGoal) || DEFAULT_GOAL;
      const remaining = Math.max(goal - cart.total_price, 0);
      const progress = Math.min(Math.max((cart.total_price / goal) * 100, 0), 100);
      const title = banner.querySelector('[data-cassava-free-shipping-title]');
      const subtitle = banner.querySelector('[data-cassava-free-shipping-subtitle]');
      const bar = banner.querySelector('[data-cassava-free-shipping-progress]');
      const hideWhenEmpty = banner.dataset.cassavaHideWhenEmpty === 'true';
      banner.hidden = hideWhenEmpty && cart.item_count === 0;

      if (overWeight) {
        if (title) title.textContent = `Tu pedido pesa ${formatKg(cart.total_weight)}: el envío gratis cubre pedidos de hasta 20 kg.`;
        if (subtitle) subtitle.textContent = 'Verás el costo de envío según el peso en el checkout. ¿Pedido grande? Cotízalo por WhatsApp.';
      } else if (remaining > 0) {
        if (title) title.textContent = `Te faltan ${formatMoney(remaining)} para obtener envío gratis.`;
        if (subtitle) subtitle.textContent = 'Envío estándar gratis desde $1,500 en pedidos de hasta 20 kg.';
      } else {
        if (title) title.textContent = '¡Ya tienes envío gratis!';
        if (subtitle) subtitle.textContent = 'Envío estándar Estafeta sin costo en pedidos de hasta 20 kg.';
      }
      if (bar) bar.style.width = `${progress}%`;
      updateShippingEstimate(banner, cart);
      updateLoyaltyNote(banner, cart);
    });

    const cartFooter = document.getElementById('main-cart-footer');
    if (cartFooter) cartFooter.classList.toggle('is-empty', cart.item_count === 0);
  }

  async function fetchCart() {
    ensureDrawerBanner();
    if (!document.querySelector('[data-cassava-free-shipping-banner]')) return null;
    if (requestInFlight) return requestInFlight;

    const cartUrl = `${window.routes?.cart_url || '/cart'}.js`;
    requestInFlight = fetch(cartUrl, {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    })
      .then((response) => {
        if (!response.ok) throw new Error('Unable to refresh cart');
        return response.json();
      })
      .then((cart) => {
        updateBanner(cart);
        return cart;
      })
      .catch(() => null)
      .finally(() => { requestInFlight = null; });

    return requestInFlight;
  }

  function initialRefresh() {
    ensureDrawerBanner();
    fetchCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialRefresh, { once: true });
  } else {
    initialRefresh();
  }

  document.addEventListener('cassava:cart-changed', (event) => {
    ensureDrawerBanner();
    const cart = event.detail?.cart;
    if (cart && typeof cart.total_price === 'number') updateBanner(cart);
    else fetchCart();
  });

  window.addEventListener('pageshow', () => { fetchCart(); });
  document.addEventListener('shopify:section:load', () => { fetchCart(); });

  window.CassavaCartProgress = { refresh: fetchCart, update: updateBanner };
})();

// Selector de retiro (snippet cassava-pickup-select): dos botones (envío / recoger) y la lista de puntos.
// Guarda el atributo "Recoger en"; vacío = envío a domicilio.
(function () {
  const ICON_CHECK = '<svg class="cassava-icon" width="1.15em" height="1.15em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';
  const MODE_KEY = 'cassavaPickupMode';
  const HINT_RECOGER = 'Almacén: listo en 1 a 2 días hábiles · Sucursal: hasta 7 días. Te avisamos por correo cuando esté listo.';
  const HINT_ALMACEN = ICON_CHECK + ' Guardado. En el checkout elige <strong>Retiro</strong>. Listo en 1 a 2 días hábiles; te avisamos por correo, no vayas antes.';
  const HINT_SUCURSAL = ICON_CHECK + ' Guardado. En el checkout elige <strong>Retiro</strong>. Llega a tu sucursal en hasta 7 días; te avisamos por correo cuando esté listo, no vayas antes.';
  if (window.CassavaPickupInit) return;
  window.CassavaPickupInit = true;

  function storedMode() { try { return sessionStorage.getItem(MODE_KEY); } catch (e) { return null; } }
  function storeMode(mode) { try { sessionStorage.setItem(MODE_KEY, mode); } catch (e) {} }

  function setMode(mode) {
    document.querySelectorAll('[data-cassava-pickup]').forEach(function (box) {
      box.setAttribute('data-mode', mode);
      box.querySelectorAll('[data-cps-mode]').forEach(function (b) {
        b.setAttribute('aria-checked', b.getAttribute('data-cps-mode') === mode ? 'true' : 'false');
      });
    });
  }

  function save(value, hints, okHtml) {
    hints.forEach(function (h) { h.textContent = 'Guardando…'; });
    return fetch((window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { 'Recoger en': value } })
    })
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function () { hints.forEach(function (h) { h.innerHTML = okHtml; }); })
      .catch(function () { hints.forEach(function (h) { h.textContent = 'No se pudo guardar. Intenta de nuevo.'; }); });
  }

  // Si eligió "Recoger" pero aún no escoge el punto, se conserva al redibujarse el carrito.
  function restore() {
    if (storedMode() !== 'recoger') return;
    document.querySelectorAll('[data-cassava-pickup][data-mode="envio"]').forEach(function (box) {
      var sel = box.querySelector('[data-cassava-pickup-select]');
      if (sel && !sel.value) setMode('recoger');
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-cps-mode]');
    if (!btn) return;
    var mode = btn.getAttribute('data-cps-mode');
    storeMode(mode);
    setMode(mode);
    var selects = document.querySelectorAll('[data-cassava-pickup-select]');
    var hints = Array.prototype.slice.call(document.querySelectorAll('[data-cassava-pickup-hint]'));
    if (mode === 'envio') {
      var had = Array.prototype.some.call(selects, function (s) { return s.value; });
      selects.forEach(function (s) { s.value = ''; });
      if (had) save('', hints, HINT_RECOGER);
    }
  });

  document.addEventListener('change', function (event) {
    var select = event.target.closest && event.target.closest('[data-cassava-pickup-select]');
    if (!select) return;
    var value = select.value;
    document.querySelectorAll('[data-cassava-pickup-select]').forEach(function (s) { if (s !== select) s.value = value; });
    storeMode('recoger');
    setMode('recoger');
    var hints = Array.prototype.slice.call(document.querySelectorAll('[data-cassava-pickup-hint]'));
    save(value, hints, !value ? HINT_RECOGER : (value.indexOf('Sucursal') === 0 ? HINT_SUCURSAL : HINT_ALMACEN));
  });

  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      for (var j = 0; j < records[i].addedNodes.length; j++) {
        var n = records[i].addedNodes[j];
        if (n.nodeType === 1 && (n.matches('[data-cassava-pickup]') || n.querySelector('[data-cassava-pickup]'))) { restore(); return; }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restore); else restore();
})();
